export const Urls = {
    BaseURL: 'cdn-base-url',
    domain: 'https://pa.paweb.org',

    programId: 'a1df79d9-08fd-4b39-8058-b47300bb8b9f',
    
    // Page ids
    searchProfilePage: 'ppl-pa-portal-search',
    homePage: 'ppl-pa-portal',
    siteMap: 'ppl-pa-portal-sitemap',
    aboutPage: 'ppl-pa-portal-about',
    infoForProvidersPage: 'ppl-pa-portal-provider-info',
    infoForEmployersPage: 'ppl-pa-portal-employer-info',
    registerPage: 'ppl-pa-portal-pa-reg',
    privacyPolicyPage: 'ppl-pa-portal-privacy',
    accessibilityPage: 'ppl-pa-portal-accessibility',
    termsPage: 'ppl-pa-portal-terms',
    directProviderReg: 'ppl-pa-portal-provider-reg',
    directEmployerReg: 'ppl-pa-portal-employer-reg',
    recruitingPersonalAssistantPage: 'ppl-pa-portal-pa-recruitment',
    paSpare: 'ppl-pa-portal-spare',
    // beingGoodEmployerPage: 340,
    // contingenciesPage: 341,
    // peerSupportPage: 342,
    // dealingPage: 343,
    // contactDetailsPage: 344,
    // selfEmployedPersonalAssistantPage: 345,
    // supportForPersonalAssistantPage: 346,

    
    // Form ids
  
}